import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionsContext';
import { isSessionExpiredSync } from '../utils/authSession';
import LoadingSpinner from './LoadingSpinner';
import './PermissionGuard.css';

const ProtectedRoute = () => {
    const token = localStorage.getItem('token');
    const { isSessionExpired } = useAuth();
    const { isPermissionsLoading, hasFlowAccess } = usePermissions();

    // Prefer the sync flag so we don't redirect away before React state commits —
    // that race was clearing the modal and re-showing it after the next login.
    const sessionExpired = isSessionExpired || isSessionExpiredSync();

    if (token === null && !sessionExpired) {
        return <Navigate to="/" replace />;
    }

    if (isPermissionsLoading && !sessionExpired) {
        return (
          <div className="permissions-loading-banner">
            <LoadingSpinner size="md" variant="primary" />
          </div>
        );
    }

    if (!hasFlowAccess && !sessionExpired) {
        return <Navigate to="/onboarding/pending" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
